import React, { useState, useEffect } from "react";

const Faqs = () => {
  const [qst, setQst] = useState([
    {
      qst: "¿Es seguro vender mi arte en el marketplace?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Se puede pagar o cobrar con criptomonedas? ¿Y con FIAT?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Existe algún tipo de coste adicional para un artista?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
  ]);

  const Questions = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className="item flex flex-col">
        <div className="qst flex aic justify-between">
          <div className="qst-lbl">{data.qst}</div>
          <div className="ico cursor-pointer" onClick={(e) => setOpen(!open)}>
            {open ? (
              <img src="./images/minusIcon.svg" className="img" />
            ) : (
              <img src="./images/PlusIcon.svg" className="img" />
            )}
          </div>
        </div>
        <div className={`ans ${open ? "open" : ""}`}>
          SI. Gracias al blockchain y a los smart contracts auditados ofrecemos
          una seguridad inquebrantable.
        </div>
      </div>
    );
  };
  return (
    <div className="faqs-detail flex flex-col">
      <div className="faqs-title-sec flex aic jc">
        <div className="faqs-title">FAQs</div>
      </div>
      <div className="wrap wrapWidth flex flex-col">
        <div className="how-help-tag">¿En qué podemos ayudarte?</div>
        <div className="seach-box flex aic jc">
          <input
            type="text"
            className="txt cleanbtn"
            placeholder=" Escribe aqui ..."
          />
          <div className="btn button">BUSCAR</div>
        </div>
        <div className="faqs-block">
          <div className="blk-left flex flex-col">
            <div className="le-item flex aic">
              <img src="./images/numb1.svg" className="img" />
              <div className="le-lbl">Acerca de los artistas y sus obras</div>
            </div>
            <div className="le-item flex aic">
              <img src="./images/numb2.svg" className="img" />
              <div className="le-lbl">Acerca del proceso de compra</div>
            </div>
            <div className="le-item flex aic">
              <img src="./images/numb3.svg" className="img" />
              <div className="le-lbl">Envíos</div>
            </div>
            <div className="le-item flex aic">
              <img src="./images/numb4.svg" className="img" />
              <div className="le-lbl">
                Funcionamiento y gestión del marketplace
              </div>
            </div>
            <div className="le-item flex aic">
              <div className="le-lbl">
                Si no has encontrado la respuesta da tu pregunta
              </div>
            </div>
            <div className="le-item flex aic jc ">
              <div className="btn button">Contactanos</div>
            </div>
          </div>
          <div className="blk-right">
            <div className="le-item flex aic">
              <img src="./images/numb1.svg" className="img" />
              <div className="le-lbl">Acerca de los artistas y sus obras</div>
            </div>
            <div className="faqs-sec flex flex-col">
              <div className="faqs-blk flex flex-col">
                {qst.map((item, index) => (
                  <Questions data={item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
